import { Check } from 'lucide-react';
import { cn } from '@/lib/utils/cn';

/**
 * Los pasos de un asistente (mapa de diseño 226, hallazgo 8): una línea con
 * números, un tilde en los hechos y el actual en azul. La misma pieza en
 * «Crear una estrategia» y en «Nueva regla». `actual` empieza en 0.
 */
export function PasosDelAsistente({
  pasos,
  actual,
  className,
}: {
  pasos: readonly string[];
  actual: number;
  className?: string;
}) {
  return (
    <ol aria-label="Pasos" className={cn('flex gap-2 pt-2', className)}>
      {pasos.map((p, i) => {
        const estado = i < actual ? 'hecho' : i === actual ? 'actual' : 'falta';
        return (
          <li
            key={p}
            data-estado={estado}
            aria-current={estado === 'actual' ? 'step' : undefined}
            className={cn(
              'flex flex-1 items-center gap-2 border-t-2 pt-2 text-sm',
              estado === 'falta' && 'border-border text-muted-foreground',
              estado === 'hecho' && 'border-primary text-foreground/80',
              estado === 'actual' && 'border-primary font-semibold text-foreground'
            )}
          >
            <span
              aria-hidden="true"
              className={cn(
                'inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full border text-xs font-semibold',
                estado === 'falta' && 'border-border bg-campo text-muted-foreground',
                estado === 'hecho' && 'border-primary/40 bg-primary/10 text-primary',
                estado === 'actual' && 'border-primary bg-primary text-primary-foreground'
              )}
            >
              {estado === 'hecho' ? <Check className="h-3 w-3" /> : i + 1}
            </span>
            {/* Ronda final (C9): el tilde es aria-hidden; el lector oye «Hecho: ». */}
            {estado === 'hecho' && <span className="sr-only">Hecho: </span>}
            {p}
          </li>
        );
      })}
    </ol>
  );
}
